export default __webpack_public_path__ + "static/media/profile-img.348a19ca.jpg";